import { Block } from '@/components/base/Block'
import { Text3 } from '@/components/base/Text'
import { useApp } from '@/hooks/useApp'
import useIsMobile from '@/hooks/useMobile'
import borderRadius, { type BorderRadiusKeyType } from '@/styles/border_radius'
import { align } from '@/styles/display'
import { fontSize, fontWeight } from '@/styles/font'
import spaceStyle from '@/styles/space'

interface ConsideringLabelProps {
  isShow?: boolean
  isAbsolute?: boolean
  rounded?: BorderRadiusKeyType | undefined
  isTransparent?: boolean
  top?: string | number
}

const ConsideringLabel = ({
  isShow = false,
  isAbsolute = true,
  rounded = borderRadius.M,
  isTransparent = false,
  top
}: ConsideringLabelProps): JSX.Element => {
  const app = useApp()
  const borderStyle = `1px solid rgba(0, 0, 0, 0.12)`
  const isMobile = useIsMobile()

  return isShow ? (
    <Block
      borderRadius={{
        upper: rounded
      }}
      textAlign={align.CENTER}
      backgroundColor={app.theme.primaryMainColor}
      style={{
        position: isAbsolute ? 'absolute' : 'unset',
        top,
        left: '0',
        width: '100%',
        borderTop: `${borderStyle}`,
        borderBottom: `${borderStyle}`,
        opacity: '0.4'
      }}
    >
      <Text3
        fontSize={isMobile ? fontSize.XXS : fontSize.S}
        fontWeight={fontWeight.Bold}
        margin={{ vertical: spaceStyle.NONE }}
        padding={{ vertical: spaceStyle.S }}
        textColor={app.theme.whiteColor}
      >
        {'検討中'}
      </Text3>
    </Block>
  ) : (
    <></>
  )
}

export default ConsideringLabel
